<template>
  <b-modal id="delete-file-confirmation-modal" hide-footer centered hide-backdrop>
    <template slot="modal-title">
      Удаление файла
    </template>
    <p class="my-1 text-center">Вы уверены, что хотите удалить данный файл?</p>
    <b-row class="mt-4">
      <b-col>
        <b-button block variant="primary" @click="onDeleteFile">
          Удалить
        </b-button>
      </b-col>
      <b-col>
        <b-button block variant="outline-primary" @click="$bvModal.hide('delete-file-confirmation-modal')">
          Отмена
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalDeleteFile',
  methods: {
    onDeleteFile() {
      this.$emit('delete')
    }
  }
}
</script>

<style scoped>

</style>
